import React from "react";
import LoadingStates from "../App.js";
import PropTypes from "prop-types";


function Payments(props) {
	let payments = props.payments;
	switch (props.loadingState) {
	case LoadingStates.inProgress:
		return (
			<h2>Loading Payments</h2>
		);

	case LoadingStates.failed:
		return (
			<h2 className="loadingError">There was an error loading the recent payment history</h2>
		);
	default:
		break;
	}

	let dateOpts = { month: "long", day:"numeric", year:"numeric"};
	let paymentsSinceStr = props.startDate.toLocaleDateString("en-US", dateOpts);

	if (payments == null || payments.length === 0) {
		return (
			<div className="CustomerAccountInfo-Payments">
				<h2>No Payments Posted Since {paymentsSinceStr}</h2>
			</div>
		);
	}

	let totalCredit = 0;
	let paymentSummaries = payments.map(function(payment) {
		let id = payment.id;
		let date = payment.transDate;
		let type = payment.payMethod.description;
		let reference = payment.reference;
		let payAmount = payment.amount;
		
		/* The applyto JSON all looks like this:
			"unapplied": [
     			 "java.util.ArrayList",
				[]
			]
		*/
		let unApplied = payment.unapplied[1];
		let availableAmt = unApplied.reduce((total, applyto) => applyto.amount + total, 0);
		let appliedAmt = payAmount - unApplied;
		
		totalCredit = totalCredit + availableAmt;
		return { 
			id: id, 
			date: date, 
			type: type, 
			reference: reference, 
			payAmount: payAmount, 
			applied: appliedAmt,
			available: availableAmt
		};
	});

	return (
		<div className="CustomerAccountInfo-Payments">
			<h2>Payments Posted Since {paymentsSinceStr}</h2>
			<table>
				<thead>
					<tr>
						<th>Number</th>
						<th>Date</th>
						<th>Type</th>
						<th>Reference</th>
						<th className="money">Amount</th>
						<th className="money">Applied</th>
						<th className="money">Available</th>
					</tr>
				</thead>
				<tbody>
					{paymentSummaries.map(payment => <Payment key={payment.id} paymentSummary={payment}/>)}
				</tbody>
				<tfoot>
					<tr>
						<th className="money" colSpan="6">Total Credit on Account</th>
						<th className="money">{totalCredit.formatMoney() }</th>
					</tr>
				</tfoot>
			</table>

		</div>
	);
}

Payments.propTypes = {
	payments: PropTypes.array,
	loadingState: PropTypes.number,
	startDate: PropTypes.objectOf(Date)
};

function Payment(props) {
	return (
		<tr>
			<td>{props.paymentSummary.id}</td>
			<td>{props.paymentSummary.date.toLocaleDateString()}</td>
			<td>{props.paymentSummary.type}</td>
			<td>{props.paymentSummary.reference}</td>
			<td className="money">{props.paymentSummary.payAmount.formatMoney()}</td>
			<td className="money">{props.paymentSummary.applied.formatMoney()}</td>
			<td className="money">{props.paymentSummary.available.formatMoney()}</td>
		</tr>
	);
}

Payment.propTypes = {
	paymentSummary: PropTypes.object
};

export default Payments;


// WEBPACK FOOTER //
// ./src/components/Payments.js